<div id="analytics-container">
    <user-search [initialValue]="search" (searchChange)="searchQuizResults($event)"></user-search>
    <div *ngIf="quizzes">
        <quiz-chart *ngFor="let quiz of quizzes" [quiz]="quiz" [date_from]="date_from" [date_to]="date_to" [search]="search"></quiz-chart>
    </div>
    <div *ngIf="noData"> No data available </div>
  </div>